export function widthState(element, width) {
    const updateWidth = (width) => element.style.setProperty('width', width);
    let unsub = width.subscribe(updateWidth);
    return {
        update(width) {
            unsub();
            unsub = width.subscribe(updateWidth);
        },
        destroy() {
            unsub();
        }
    };
}
